import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

import { ApplicationState } from 'src/store'
import { getConferences } from 'src/core/store/ducks/conferences/actions'
import currencyMask from 'src/components/Formik/InputCurrency/mask'
import history from 'src/config/routes/history'
import useDocumentTitle from 'src/hooks/use-document-title'

import * as CSS from '../styles'
import Header from '../components/Header'
import StatusFilter from '../../components/StatusFilter'
import Table, { DataSource } from '../../components/Table'

export default function Conferences() {
  useDocumentTitle('web.side.conferences')
  const { conferences } = useSelector((state: ApplicationState) => ({
    conferences: state.conferences
  }))
  const dispatch = useDispatch()

  const [list, setList] = useState<DataSource[]>([])
  const [currentPage, setCurrentPage] = useState<number>(1)

  useEffect(() => {
    dispatch(
      getConferences({ filterStatus: conferences.filterStatus, page: 1 })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setList(
      conferences.list.map(
        ({
          checkers,
          cost,
          request_conferences,
          request_id,
          request_number,
          requested_on,
          status,
          sync_status,
          title
        }) => ({
          checkers,
          cost: currencyMask({ formatStr: true, value: cost }).maskedValue,
          extra: {
            request_conference_id: request_conferences[0].request_conference_id
          },
          id: request_id,
          key: request_id,
          number: request_number,
          startDate: moment.unix(requested_on).format('DD/MM/YYYY'),
          status,
          sync_status,
          title,
          users: request_conferences.map(({ request_user_data, status }) => ({
            gender: request_user_data.traveler.gender,
            name: request_user_data.traveler.name,
            reason: request_user_data.reason,
            status,
            user_id: request_user_data.traveler.user_id
          }))
        })
      )
    )
  }, [conferences.list])

  return (
    <>
      <Header error={conferences.error} title="web.side.conferences" />
      <CSS.HeaderFilters>
        <StatusFilter
          defaultValue={conferences.filterStatus}
          onChange={values => {
            dispatch(getConferences({ filterStatus: values, page: 1 }))
            setCurrentPage(1)
          }}
          options={['pending', 'approved', 'canceled', 'reproved', 'expired']}
        />
      </CSS.HeaderFilters>
      <Table
        conferences
        currentPage={currentPage}
        dataSource={list}
        loading={conferences.loading}
        onChange={page => {
          dispatch(
            getConferences({ filterStatus: conferences.filterStatus, page })
          )
          setCurrentPage(page)
        }}
        onRow={(record: DataSource) => ({
          onClick: () =>
            history.push(
              `/conferences/${record.extra.request_conference_id}/request/${record.id}`
            )
        })}
        totalPages={conferences.total_results}
      />
    </>
  )
}
